import React from 'react';

import { ProjectTabs } from 'widgets/ProjectList';

import { useScrollRestoration } from 'shared/lib/react-router';

const ProjectsPage: React.FC = () => {
  useScrollRestoration();

  return <ProjectTabs />;
};

export default ProjectsPage;
